import { render, staticRenderFns } from "./BuildType.vue?vue&type=template&id=2f47f872&scoped=true"
import script from "./BuildType.vue?vue&type=script&lang=js"
export * from "./BuildType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f47f872",
  null
  
)

export default component.exports